import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { File } from '@/types';

interface FilesResponse {
  files: File[];
  pageCount: number;
  currentPage: number;
  totalCount: number;
}

const useGetFiles = (caseId: string, page: number, search?: string, fileType?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const params = new URLSearchParams();

  if (search) {
    params.set('search', search);
  }
  if (fileType) {
    params.set('fileType', fileType);
  }
  if (page) {
    params.set('page', page.toString());
  }

  return useQuery<FilesResponse, Error>(
    [QueryEntity.Files, { caseId }, { page, search, fileType }],
    async () => {
      return await fetch(`${APIBaseChronos}/api/files/${caseId}?${params.toString()}`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, keepPreviousData: true },
  );
};

export default useGetFiles;
